import enCompanyFeed from './en';
import ruCompanyFeed from './ru';

export default {
  en: {
    ...enCompanyFeed,
  },
  ru: {
    ...ruCompanyFeed,
  },
};
